// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-page-js" + "-" + "25af98f205a47fa6a026" + ".js";
};